import { Icon } from "@/components/icons";

type Props = {
  checked: boolean;
  indeterminate?: boolean;
  onClick?: () => void;
  label: string;
};

export function SelectCheckbox({ checked, indeterminate = false, onClick, label }: Props) {
  const iconName = checked
    ? "check_box"
    : indeterminate
      ? "indeterminate_check_box"
      : "check_box_outline_blank";
  return (
    <span
      role={onClick ? "button" : undefined}
      aria-label={label}
      aria-pressed={onClick ? checked : undefined}
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
      className={[
        "flex size-5 items-center justify-center",
        checked || indeterminate ? "text-green-500" : "text-grey-300",
        onClick ? "cursor-pointer hover:text-black" : "",
      ].join(" ")}
    >
      <Icon name={iconName} size={20} />
    </span>
  );
}
